export class PuzzleGameServer{
    static evaluateOnServer(exercise: any, correctSolution: any, userSolution: any): Evaluated {
        let goodSolutions = 0;
        userSolution.forEach((element: number) => {
            if (element) goodSolutions++;
        });
        return { success: goodSolutions == userSolution.length, solution: [], successPercent: (userSolution.length - goodSolutions) / userSolution.length * 100 };
    }
}